let amount;
let adviserFee = 2;
const initialFee = 1.5;

document.addEventListener('DOMContentLoaded', () => {
  const amountInput = document.getElementById('amount');
  const adviserFeeInput = document.getElementById('fee');
  const adviserFeeSpan = document.getElementById('adviser-fee');
  const initialFeeSpan = document.getElementById('initial-fee');
  const dealingFeeSpan = document.getElementById('dealing-fee');
  const totalFeeSpan = document.getElementById('total-fee');
  const netDisplaySpan = document.getElementById('net-amount-display');
  const adviserDisplaySpan = document.getElementById('adviser-fee-display');
  const octopusPaymentSpan = document.getElementById('octopus-payment-value');

  // Make sure there are inputs available, avoids errors.
  if (!amountInput || !adviserFeeInput) {
    return;
  }

  amount = amountInput.value || 10000;
  adviserFee = adviserFeeInput.value || 2;

  const numberWithCommas = (number) => parseFloat(number).toLocaleString('en');

  const formatOutput = (unformattedOutput) =>
    numberWithCommas(parseFloat(unformattedOutput).toFixed(2));

  const formatCurrency = (number) => +parseFloat(number).toFixed(2);

  const updateCalculations = () => {
    amount = parseFloat(amount);
    const dealingFeeAmount = formatCurrency(amount / 100);
    const initialFeeAmount = formatCurrency(
      ((amount + dealingFeeAmount) / (100 - initialFee)) * initialFee,
    );
    const adviserFeeAmount = formatCurrency(
      ((amount + dealingFeeAmount + initialFeeAmount) / (100 - adviserFee)) * 100 -
        (amount + dealingFeeAmount + initialFeeAmount),
    );
    const totalFees = formatCurrency(adviserFeeAmount + initialFeeAmount + dealingFeeAmount);
    const totalPayment = formatCurrency(amount + totalFees);

    // display users input in calculator
    adviserFeeSpan.innerHTML = `£ ${formatOutput(adviserFeeAmount)}`;
    netDisplaySpan.innerHTML = `£ ${formatOutput(amount)}`;
    adviserDisplaySpan.innerHTML = `${formatOutput(adviserFee)}%`;

    initialFeeSpan.innerHTML = `£ ${formatOutput(initialFeeAmount)}`;
    dealingFeeSpan.innerHTML = `£ ${formatOutput(dealingFeeAmount)}`;
    totalFeeSpan.innerHTML = `£ ${formatOutput(totalFees)}`;
    octopusPaymentSpan.innerHTML = `£ ${formatOutput(totalPayment)}`;
  };

  const validateAmount = () => {
    if (amount === null || amount === undefined || amount === '') {
      return 'Please enter your desired amount';
    }
    if (amount < 1) {
      return 'Minimum amount: 1';
    }
    if (amount > 99999999) {
      return 'Maximum amount: 99999999';
    }
    return true;
  };

  const validateAdviserFee = () => {
    if (adviserFee === null || adviserFee === undefined || adviserFee === '') {
      return 'Please enter your desired fee percentage';
    }
    if (adviserFee > 4.5 || adviserFee < 0) {
      return 'Adviser fee must be between 0 and 4.5%';
    }
    return true;
  };

  const amountChanged = () => {
    window.setTimeout(() => {
      amount = amountInput.value;
      const validation = validateAmount();
      if (validation !== true) {
        amountInput.classList.add('input-invalid');
        document.getElementById('amount-error-message').innerHTML = validation;
      } else {
        updateCalculations();
        if (amountInput.classList.contains('input-invalid')) {
          amountInput.classList.remove('input-invalid');
          document.getElementById('amount-error-message').innerHTML = '';
        }
      }
    }, 1);
  };

  const adviserFeeChanged = () => {
    window.setTimeout(() => {
      adviserFee = adviserFeeInput.value;
      const validation = validateAdviserFee();
      if (validation !== true) {
        adviserFeeInput.classList.add('input-invalid');
        document.getElementById('adviser-error-message').innerHTML = validation;
      } else {
        updateCalculations();
        if (adviserFeeInput.classList.contains('input-invalid')) {
          adviserFeeInput.classList.remove('input-invalid');
          document.getElementById('adviser-error-message').innerHTML = '';
        }
      }
    });
  };

  // listen to change explicitly for number input incremental clicks
  amountInput.addEventListener('keydown', amountChanged);
  amountInput.addEventListener('change', amountChanged);
  adviserFeeInput.addEventListener('keydown', adviserFeeChanged);
  adviserFeeInput.addEventListener('change', adviserFeeChanged);

  updateCalculations();
});
